import React from "react";
import { Form, Col } from "react-bootstrap";
import { ErrorMessage } from "@hookform/error-message";

function EmployeeId(props) {
  return (
    <Form.Group as={Col} controlId="">
      <Form.Label>Empolyee ID</Form.Label>
      <Form.Control
        placeholder=""
        type="text"
        {...props.register("EmployeeId", {
          required: props.required,
        })}
      />
      <ErrorMessage
        errors={props.errors}
        name="EmployeeId"
        render={({ message }) => <div style={{ color: "red" }}>{message}</div>}
      />
    </Form.Group>
  );
}
export default EmployeeId;
